<template lang="html">

  <div class="politica-de-privacidad">

    <section class="intro-legales column-center launch">

      <h2 class="subtitle-intro">
        <span>{{$t("vistas.politica_proteccion")}}</span>
      </h2>

    </section> 

    <section class="textos-legales container">
      

        <p>La Dirección / Órgano de Gobierno de <strong>ALDONZA GOURMET S.A.U.</strong> (en adelante, el responsable del tratamiento), asume la máxima responsabilidad y compromiso con el establecimiento, implementación y mantenimiento de la presente Política de Protección de Datos, garantizando la mejora continua del responsable del tratamiento con el objetivo de alcanzar la excelencia en relación con el cumplimiento del Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016, relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos y por el que se deroga la Directiva 95/46/CE (Reglamento general de protección de datos) (DOUE L 119/1, 04-05-2016), y de la normativa española de protección de datos de carácter personal (Ley Orgánica, legislación sectorial específica y sus normas de desarrollo).</p>

<p>La Política de Protección de Datos de <strong>ALDONZA GOURMET S.A.U.</strong> descansa en el principio de responsabilidad proactiva, según el cual el responsable del tratamiento es responsable del cumplimiento del marco normativo y jurisprudencial que gobierna dicha Política, y es capaz de demostrarlo ante las autoridades de control competentes.</p>

<p>En tal sentido, el responsable del tratamiento se regirá por los siguientes principios que deben servir a todo su personal como guía y marco de referencia en el tratamiento de datos personales:</p>

<p>1.  <u>Protección de datos desde el diseño:</u> el responsable del tratamiento aplicará, tanto en el momento de determinar los medios de tratamiento como en el momento del propio tratamiento, medidas técnicas y organizativas apropiadas, como la seudonimización, concebidas para aplicar de forma efectiva los principios de protección de datos, como la minimización de datos, e integrar las garantías necesarias en el tratamiento.</p>

<p>2.  <u>Protección de datos por defecto:</u> el responsable del tratamiento aplicará las medidas técnicas y organizativas apropiadas con miras a garantizar que, por defecto, solo sean objeto de tratamiento los datos personales que sean necesarios para cada uno de los fines específicos del tratamiento.</p>

<p>3.  <u>Protección de datos en el ciclo de vida de la información:</u> las medidas que garanticen la protección de los datos personales serán aplicables durante el ciclo completo de la vida de la información.</p>

<p>4.  <u>Licitud, lealtad y transparencia:</u> los datos personales serán tratados de manera lícita, leal y transparente en relación con el interesado. </p>

<p>5.  <u>Limitación de la finalidad:</u> los datos personales serán recogidos con fines determinados, explícitos y legítimos, y no serán tratados ulteriormente de manera incompatible con dichos fines.</p>

<p>6.  <u>Minimización de datos:</u> los datos personales serán adecuados, pertinentes y limitados a lo necesario en relación con los fines para los que son tratados.</p>
 
<p>7.  <u>Exactitud:</u> los datos personales serán exactos y, si fuera necesario, actualizados; se adoptarán todas las medidas razonables para que se supriman o rectifiquen sin dilación los datos personales que sean inexactos con respecto a los fines para los que se tratan.</p>

<p>8.  <u>Limitación del plazo de conservación:</u> los datos personales serán mantenidos de forma que se permita la identificación de los interesados durante no más tiempo del necesario para los fines del tratamiento de los datos personales.</p>

<p>9.  <u>Integridad y confidencialidad:</u> los datos personales serán tratados de tal manera que se garantice una seguridad adecuada de los datos personales, incluida la protección contra el tratamiento no autorizado o ilícito y contra su pérdida, destrucción o daño accidental, mediante la aplicación de medidas técnicas u organizativas apropiadas. </p>

<p>10. <u>Información y formación:</u> una de las claves para garantizar la protección de los datos personales es la formación e información que se facilite al personal involucrado en el tratamiento de los mismos. Durante el ciclo de vida de la información, todo el personal con acceso a los datos será convenientemente formado e informado acerca de sus obligaciones en relación con el cumplimiento de la normativa de protección de datos.</p>

<p>La Política de Protección de Datos de <strong>ALDONZA GOURMET S.A.U.</strong> es comunicada a todo el personal del responsable del tratamiento y puesta a disposición de todas las partes interesadas.</p>

<p>En su consecuencia, la presente Política de Protección de Datos involucra a todo el personal del responsable del tratamiento, que debe conocerla y asumirla, considerándola como propia, siendo cada miembro responsable de aplicarla y de verificar las normas de protección de datos aplicables a su actividad, así como identificar y aportar las oportunidades de mejora que considere oportunas con el objetivo de alcanzar la excelencia en relación con su cumplimiento.</p>

<p>Esta Política será revisada por la Dirección / Órgano de Gobierno <strong>ALDONZA GOURMET S.A.U</strong>, tantas veces como se considere necesario, para adecuarse, en todo momento, a las disposiciones vigentes en materia de protección de datos de carácter personal.</p>

    </section>




  </div>
</template>

<script lang="js">
  export default  {
    name: 'politica-de-proteccion-datos',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .politica-de-privacidad {

  }
</style>



// WEBPACK FOOTER //
// src/components/views/politica-de-privacidad.vue